export function getYearRange(start = 1962, end = 2025) {
  const years = [];
  // eslint-disable-next-line no-plusplus
  for (let year = start; year <= end; year++) {
    years.push(year);
  }
  return years;
}
